// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3SPNz","content":"styles_content__2J_ya","selectAll":"styles_selectAll__3K5F-"};